export default "__VITE_ASSET__19a0c9ae__"